import {PropsWithChildren, useCallback, useState} from 'react';
import * as styles from './inputPrefix.module.css';
import {useScreenshot} from '../../../../hooks/useScreenshot';
import resizeImage from '../../../../helpers/screenshot/resizeImage';
import Button from '../../button/button';
import {AddIcon, DeleteIcon} from '../../icons';

interface IScreenshotInput {
    title?: string,
    onChange?: (screenshot: string | null) => void,
}

const ScreenshotInput = ({
    title,
    onChange,
}: PropsWithChildren<IScreenshotInput>) => {
    const {captureScreenshot} = useScreenshot();
    const [thumbnail, setThumbnail] = useState<string | null>(null);

    const resolveScreenshotCapture = useCallback(async () => {
        const screenshotData = await captureScreenshot();

        if (!screenshotData) {
            return;
        }

        const thumbnailData = await resizeImage(screenshotData, {maxWidth: 500});

        setThumbnail(thumbnailData);
        onChange?.(screenshotData);
    }, [captureScreenshot, onChange]);

    return (
        <div className={styles.root}>
            <div className={styles.title}>
                <span>{title}</span>
            </div>
            {thumbnail && (
                <div className={styles.inputWrapper}>
                    <div className={styles.thumbnailWrapper}>
                        <img
                            src={thumbnail || ''}
                            alt="Screenshot thumbnail"
                            className={styles.thumbnail}
                        />
                    </div>
                </div>
            )}
            <div className={styles.buttons}>
                {thumbnail ? (
                    <Button
                        text="Remove screenshot"
                        color="error"
                        size="medium"
                        onClick={() => {
                            setThumbnail(null);
                            onChange?.(null);
                        }}
                        icon={DeleteIcon}
                    />
                ) : (
                    <Button
                        text="Capture screenshot"
                        variant='outline'
                        size="medium"
                        onClick={resolveScreenshotCapture}
                        icon={AddIcon}
                    />
                )}
            </div>
        </div>
    );
};

export default ScreenshotInput;
